// extracted by mini-css-extract-plugin
module.exports = {"WhatMakesUsGreatContainer":"WhatMakesUsGreat-module--WhatMakesUsGreatContainer--Vwm6T","WhatMakesUsGreat":"WhatMakesUsGreat-module--WhatMakesUsGreat--2b8-r"};